/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "../FluxCommon/Actions"], function (require, exports, Actions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadsActions = /** @class */ (function (_super) {
        __extends(WorkloadsActions, _super);
        function WorkloadsActions() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        WorkloadsActions.getKey = function () {
            return "workloads-actions";
        };
        WorkloadsActions.prototype.initialize = function () {
            this._deploymentsFetched = new Actions_1.Action();
            this._replicaSetsFetched = new Actions_1.Action();
            this._daemonSetsFetched = new Actions_1.Action();
            this._statefulSetsFetched = new Actions_1.Action();
            this._podsFetched = new Actions_1.Action();
        };
        Object.defineProperty(WorkloadsActions.prototype, "deploymentsFetched", {
            get: function () {
                return this._deploymentsFetched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WorkloadsActions.prototype, "replicaSetsFetched", {
            get: function () {
                return this._replicaSetsFetched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WorkloadsActions.prototype, "daemonSetsFetched", {
            get: function () {
                return this._daemonSetsFetched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WorkloadsActions.prototype, "statefulSetsFetched", {
            get: function () {
                return this._statefulSetsFetched;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(WorkloadsActions.prototype, "podsFetched", {
            get: function () {
                return this._podsFetched;
            },
            enumerable: true,
            configurable: true
        });
        return WorkloadsActions;
    }(Actions_1.ActionsHubBase));
    exports.WorkloadsActions = WorkloadsActions;
});
